@if (toggle()) {
  <section class="alert__modal">
    <section id="backdrop"></section>
    <section class="modal">
      <section class="modal__top">
        <p class="icon" [attr.data-type]="type()"></p>
        <svg
          (click)="cancel()"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          aria-hidden="true"
          role="img"
          width="45px"
          height="45px"
          preserveAspectRatio="xMidYMid meet"
          viewBox="0 0 24 24"
        >
          <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41z" fill="#667085" />
        </svg>
      </section>
      <section class="modal__body">
        <h6 class="text--lg text--semibold gray-900">{{ title() }}</h6>
        <p class="text--sm text--regular gray-600">{{ msg() }}</p>
      </section>
      <section class="action-button">
        <button class="btn btn--sm btn--primary" (click)="confirm()">{{ btnText() }}</button>
      </section>
    </section>
  </section>
}
